import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { BusinessSearchModalBase } from '../../../custom_shared/components';
import { useMemoizedInput } from '../../hooks';
import { InputIds } from '../../misc';
import { BusinessDto } from '../../../custom_shared/types';

const BusinessSearchModal: React.FC = () => {
    const appStore = useAppStore();

    const { tab, nodesStore, businessSearchStore } = appStore;

    const underwritingYearInput = useMemoizedInput(
        InputIds.GeneralInformation.UnderwritingYear,
        nodesStore.generalInformationNode?.inputs
    );

    const periodStartInput = useMemoizedInput(
        InputIds.GeneralInformation.PeriodStart,
        nodesStore.generalInformationNode?.inputs
    );

    const periodEndInput = useMemoizedInput(
        InputIds.GeneralInformation.PeriodEnd,
        nodesStore.generalInformationNode?.inputs
    );

    const handleBusinessClick = (business: BusinessDto) => {
        if (!businessSearchStore.inputsToUpdate) {
            return businessSearchStore.setModalVisible(false);
        }

        businessSearchStore.inputsToUpdate.businessIdInput.setDraftValue(business.identifier);
        businessSearchStore.inputsToUpdate.businessIdInput.validate();
        businessSearchStore.inputsToUpdate.expiringPeriodStartInput.setDraftValue(business.insuredPeriodStart);

        handleClose();
    };

    const handleClose = () => {
        businessSearchStore.setModalVisible(false);
        businessSearchStore.setInputsToUpdate(null);
    };

    return (
        <BusinessSearchModalBase
            formId={`contract-ingestion-business-search-${tab.id}`}
            businessSearchStore={businessSearchStore}
            initialFormValues={{
                underwritingYear: underwritingYearInput?.value,
                insuredPeriodStart: periodStartInput?.value,
                insuredPeriodEnd: periodEndInput?.value
            }}
            onClose={handleClose}
            onBusinessClick={handleBusinessClick}
        />
    );
};

export default observer(BusinessSearchModal);
